<app-header #header title="One Time Password"></app-header>

<ion-content>
    <form  [formGroup]="mfaForm">

    <ion-grid>
        <ion-row>
            <ion-col size="12">
                <h2 class="subheader-regular" style="text-align: center;">
                  {{
                    ('keys.data.users_login.enter_otp_capital' | translate : {Default:'Enter your one-time password.'}) || 'Enter your one-time password.'
                    }}
                </h2>
              </ion-col>
        </ion-row>
        <ion-row>
            <ion-col>
                <ion-card class="card-shadow-7">
                    <ion-grid>
                      <ion-row *ngIf="OTPsent">
                        <ion-col style="text-align: center;">
                          <ion-card class="card-shadow-3">
                            <ion-item lines="none">
                                <ion-label>{{message}}</ion-label>
                            </ion-item>
                          </ion-card>
                        </ion-col>
                      </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-card  class="card-shadow-3">
                                    <ion-item>
                                    <ion-label position="stacked">{{
                                      ('keys.data.users_login.enter_otp'
                                        | translate : {Default:'Enter your one-time password.'}) || 'Enter your one-time password.'
                                    }}</ion-label>
                                    <ion-input [disabled]="!OTPsent" formControlName="one_time_password"
                                    ></ion-input>
                                    <ng-container *ngIf="errors['one_time_password']">
                                      <ion-note color="danger" style="font-weight: bold;"
                                        >{{ errors['one_time_password'] }}
                                      </ion-note>
                                    </ng-container>
                                  </ion-item>
                                  </ion-card>
                            </ion-col>
                        </ion-row>
                        <ion-row *ngIf="!OTPsent">
                            <ion-col style="text-align: center;">
                              <ion-button [disabled]="sendingOTP " color="primary" (click)="sendOTP()">
                                <ion-label > {{
                                  ('keys.data.users_login.send_otp' | translate : {Default:'Send One-Time Password to Email'}) ||
                                    'Send One-Time Password to Email'
                                }}</ion-label>
                             <ion-spinner *ngIf="sendingOTP"></ion-spinner>  
                            </ion-button>
                            </ion-col>
                          </ion-row>
                          <ion-row *ngIf="OTPsent">
                            <ion-col style="text-align: center;">
                              <ion-button [disabled]="submitting || mfaForm.invalid || mfaForm.pristine" color="primary" (click)="submit()">
                                <ion-label > {{
                                  ('keys.data.users_login.submit' | translate : {Default:'Submit'}) ||
                                    'Submit'
                                }}</ion-label>
                             <ion-spinner *ngIf="submitting"></ion-spinner>  
                            </ion-button>
                            </ion-col>
                          </ion-row>
                    </ion-grid>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>
</form>
</ion-content>
